import { render, staticRenderFns } from "./SMSResend.vue?vue&type=template&id=cca2d752&scoped=true"
import script from "./SMSResend.vue?vue&type=script&lang=js"
export * from "./SMSResend.vue?vue&type=script&lang=js"
import style0 from "./SMSResend.vue?vue&type=style&index=0&id=cca2d752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca2d752",
  null
  
)

export default component.exports